module.exports = __webpack_public_path__ + "img/icon_final_point.2c6193cf.svg";